module.exports = __webpack_public_path__ + "media/Patrones2.46cef55c.mp4";